export default {
  submitClaim: {
    id: 'insurance_policy_details_submit_claim',
    defaultMessage: 'Submit claim',
  },
  catchUpOnMissedPayments: {
    id: 'insurance_policy_details_catch_up_on_missed_payments',
    defaultMessage: 'Catch up on missed payments to open a claim.',
  },
}
